import { call, put } from 'redux-saga/effects';
import { deleteChartOfAccountRow } from '../api';
import {
  deleteChartOfAccountRowFailure,
  deleteChartOfAccountRowSuccess,
  fetchChartOfAccountsForOrganisationRequest,
} from '../actions';
import { DeleteChartOfAccountRowRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundARY-TYPES */
export function* deleteChartOfAccountRowSaga(
  action: DeleteChartOfAccountRowRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId, accountId } = action.payload;

    const response: ApiResponse = yield call(
      deleteChartOfAccountRow,
      organisationId,
      accountId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(deleteChartOfAccountRowSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // Refresh organisation chart of accounts from backend after delete
    yield put(fetchChartOfAccountsForOrganisationRequest(organisationId));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(deleteChartOfAccountRowFailure());
  }
}

